import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TableService } from './table.service';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { RecursosService } from 'src/app/_services/recursos.service';

@Injectable({
  providedIn: 'root'
})
export class TableExtendedService extends TableService<any> {
  constructor(@Inject(HttpClient) http, @Inject(AuthService) auths, @Inject(RecursosService) recursosService) {
    super(http,auths,recursosService);
  }
}
